define('NVT.anuualupdateform.anuualupdateformBizProfile.View'
, [
    'Backbone'
  , 'nvt_anuualupdateform_biz_profile.tpl'
  , 'Backbone.FormView'
  , 'GlobalViews.Message.View'
  ,	'underscore'
  ,	'jQuery'


  ]
, function
  (
    Backbone
  , nvt_myorganisation_biz_profile_tpl
  , BackboneFormView
  , MessageView
  ,	_
  ,	jQuery

  )
{
  'use strict';

    return Backbone.View.extend({
           

        template: nvt_myorganisation_biz_profile_tpl

       // , title: Utils.translate('Edit Biz Profile')


        ,initialize: function(options)
            {
                //this.model.on('sync', _.bind(this.render, this));
                this.options = options;
                this.profile= options.profile;
                this.application = options.application;
                this.page_header = "Edit Biz Profile";	
                this.modalClass ='modal-md';  
                var self = this;
                BackboneFormView.add(this);
            }

        ,    events: 
            {
              'submit form': 'saveTheForm'
            }   
            
          ,saveTheForm: function(e)
            {
                e.preventDefault();
                e.stopImmediatePropagation();
                var self = this,
                	$target = jQuery(e.target),
			    	      user_data = $target.serializeObject();
                    user_data.requestby = self.profile;
                    user_data.folderlocfile = SC.CONFIGURATION.MyOrganisation.BizFileAttachmentId;
                    user_data.orgnisationselection = $('input[name="orgnisationselection"]:checked').map(function() {
                        return $(this).val();
                      }).get()
                    if(!user_data.fileData1)
                    {
                        self.showMessage('Please upload files in correct format only.', 'error');  
                    }
                    else if(user_data.orgnisationselection.length == 0)
                    {
                        self.showMessage('Please select file type ', 'error');
                    }
                    else{
                        var promise = BackboneFormView.saveForm.apply(this, arguments);
                        var global_view_message = new MessageView({
                          //  message: _('Thank you for submitting your request we will get in touch with you shortly').translate()
                            message: _('Thank you for submitting your request.').translate()
                        ,	type: 'success'
                        });
        
                        this.$('form').empty().html(global_view_message.render().$el.html());
                        setTimeout(function() {
                          jQuery("[data-dismiss=modal]").trigger({ type: "click" });
                      }, 1000);
                    }
               
                //self.showMessage('Thank you for submitting your request we will get in touch with you shortly', 'success');  
                this.$containerModal.addClass('fade').modal('show').data('bs.modal', null);
                return false;
            }

        , showMessage: function(message, type, field)
          {
              jQuery('.global-views-message-error').remove(); 
              var messageView = new MessageView
              ({
                      message: message
                  ,   type: type
                  ,   closable: type =='error' ? true : false
              });
              if (typeof field !== 'undefined')
              {
                  this.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
              }
              else if (type =='error'){
                this.application.getLayout().$('form').append(messageView.render().$el);
              }
              else
              {
                  this.application.getLayout().$('form').empty().html(messageView.render().$el);       
                  setTimeout(function() {
                      jQuery("[data-dismiss=modal]").trigger({ type: "click" });
                  }, 1000);
              }                
          }    

            
        ,getContext: function() {
            
            var self = this;

            return {
               message :'' ,

               title : 'Edit Biz Profile',
               
               requestby : self.profile,

               requestbyemail : self.options.cutomuparamsemail,

               internalid : self.options.cutomuparams,
               
               folderlocfile : SC.CONFIGURATION.MyOrganisation.BizFileAttachmentId
           }
         }        

    });
});
